// extracted by mini-css-extract-plugin
module.exports = {"container":"re_order_entity__container___wspEu"};